export default {
  'menu.cms.site.website': 'サイト設定',
  'menu.cms.site.sitemap': 'Sitemap',
  'menu.cms.site.robots': 'Robots',
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': '設定',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.cms.content': 'コンテンツ資産',
  'menu.cms.content.all': 'すべてのコンテンツ',
  'menu.cms.content.review': 'レビュー一覧',
  'menu.cms.content.categories': 'カテゴリ管理',
  'menu.cms.content.tags': 'タグ管理',
  'menu.cms.content.categories.master': 'コンテンツマスター',
  'menu.cms.content.categories.product': '製品コンテンツ',
  'menu.cms.content.categories.solution': 'ソリューション',
  'menu.cms.content.categories.case': '導入事例',
  'menu.cms.content.categories.article': '記事とインサイト',
  'menu.cms.content.categories.faq': 'FAQと用語',
  'menu.cms.content.categories.channel': 'チャネル版',
  'menu.cms.content.categories.archive': 'コンテンツアーカイブ',
  'menu.cms.content.material': '素材センター',
  'menu.cms.ai.topic': 'AIトピック',
  'menu.account': 'アカウント',
  'menu.cms.site.publication': '公開記録',
  'menu.cms.site.list': 'サイト一覧',
  'menu.cms.site.categories': 'カテゴリ一覧',
  'menu.cms.site.analytics': 'サイト統計',
  'menu.cms.settings.forms': 'フォーム管理',
  'menu.cms.settings.submissions': '送信記録',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
